import { Button } from "antd";
import ArrowIcon from "../../components/ArrowIcon";
import { STEPS } from "./constants";

export interface FlowActionsProps {
  activeStep: number;
  canSubmit: boolean;
  submitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export default function FlowActions({
  activeStep,
  canSubmit,
  submitting,
  onBack,
  onNext,
  onSubmit,
}: FlowActionsProps) {
  return (
    <div className="sendin-flow-actions">
      <Button
        className="sendin-back-button"
        aria-label="Forrige steg"
        disabled={activeStep === 0}
        onClick={onBack}
      >
        <ArrowIcon direction="left" size={20} />
      </Button>
      {activeStep < STEPS.length - 1 ? (
        <Button className="sendin-next-button" onClick={onNext}>
          {STEPS[activeStep]?.nextLabel ?? "Neste"} <ArrowIcon />
        </Button>
      ) : (
        <Button
          className="sendin-next-button"
          loading={submitting}
          disabled={!canSubmit}
          onClick={onSubmit}
        >
          {STEPS[activeStep]?.nextLabel} <ArrowIcon />
        </Button>
      )}
    </div>
  );
}
